export default "__VITE_ASSET__BEIveTsw__"